import React from "react";
import { Link } from "react-router-dom";
import Header from "./header"; // आपके ABHA Header का path

const LandingCreationPage = () => {
  return (
    <>
      <Header currentStep={1} />
      <div className="max-w-screen-xl mx-auto p-5 sm:p-10 md:p-16">
        <div className="text-center p-10">
          <h1 className="font-bold text-4xl mb-4">
            Create Your ABHA Number
          </h1>
          <p className="text-xl text-gray-600">
            Choose one of the following options to start your ABHA registration.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Aadhaar Option */}
          <div className="max-w-sm mx-auto border rounded-xl p-8 text-center shadow hover:shadow-lg transition">
            <img
              src="https://d2sv8898xch8nu.cloudfront.net/MediaFiles/aadhar.png"
              alt="Aadhaar"
              className="w-36 mx-auto"
            />
            <h2 className="text-2xl font-semibold mt-6">
              Register with Aadhaar
            </h2>
            <p className="text-gray-500 mt-3">
              Create your ABHA Number using your Aadhaar Card.
            </p>
            <Link
              to="/register/aadhaar"
              className="inline-block mt-6 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Continue
            </Link>
          </div>

          {/* Mobile Option */}
          <div className="max-w-sm mx-auto border rounded-xl p-8 text-center shadow hover:shadow-lg transition">
            <img
              src="https://cdn-icons-png.flaticon.com/512/15/15874.png"
              alt="Mobile"
              className="w-28 mx-auto"
            />
            <h2 className="text-2xl font-semibold mt-6">
              Register with Mobile
            </h2>
            <p className="text-gray-500 mt-3">
              Create your ABHA Number using your Mobile Number.
            </p>
            <Link
              to="/register/mobile"
              className="inline-block mt-6 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition"
            >
              Continue
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingCreationPage;